import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './style.module.scss'

interface Props {
  learningPaths: ReactNode
}

export const WithoutCourses = ({ learningPaths }: Props) => {
  const { t } = useTranslation()
  const prefix = 'courses.show.content.prerequisites.byCourses'

  return (
    <div className={styles.contentWithoutCourses}>
      <FontAwesomeIcon icon={faInfoCircle} />
      <div>
        <span>{t(`${prefix}.description.secondaryPrefix`)}</span>
        {learningPaths}
        {t(`${prefix}.description.secondarySuffix`)}
      </div>
    </div>
  )
}
